module.exports = __webpack_public_path__ + "static/media/personImportGetPersonInfo.a23af381.xlsx";